import React from "react";
import { Controller } from "react-hook-form";
import get from "lodash/get";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const AutocompleteController = ({
  control,
  name,
  rules,
  options,
  optionsById,
  getOptionLabel,
  multiple = true,
  ...props
}) => (
  <Controller
    name={name}
    control={control}
    rules={rules}
    render={({ field: { onChange, ...restProps } }) => (
      <Autocomplete
        {...restProps}
        {...props}
        multiple={multiple}
        disableCloseOnSelect
        limitTags={1}
        options={options.map(({ id }) => id)}
        onChange={(_event, items) => onChange(items)}
        getOptionLabel={
          !!getOptionLabel
            ? (option) => getOptionLabel(option, optionsById)
            : (option) => get(optionsById, [option, "name"])
        }
        renderInput={(params) => <TextField {...params} />}
        renderOption={(props, _option, { selected }) => {
          const { key, ...optionProps } = props;
          return (
            <li key={key} {...optionProps}>
              <Checkbox
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={
                  <CheckBoxIcon fontSize="small" htmlColor="var(--red-color)" />
                }
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {key}
            </li>
          );
        }}
      />
    )}
  />
);

export default AutocompleteController;
